import { render } from "./OurMission.vue?vue&type=template&id=7edba9a0"
import script from "./OurMission.vue?vue&type=script&lang=js"
export * from "./OurMission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__